import DatetimeHelper from '@/helper/DatetimeHelper.js';

export function InsuranceModel() {
    this.cost = null;
    this.coverageEndDate = null;
    this.coverageStartDate = null;
    this.policyName = null;
    this.policyNumber = null;
    this.policyStatus = null;
    this.isWarning = false;

    this.setDataFromApi = function (data) {
        this.cost = data.Cost;
        this.coverageEndDate = data.CoverageEndDate;
        this.coverageStartDate = data.CoverageStartDate;
        this.policyName = data.PolicyName;
        this.policyNumber = data.PolicyNumber;
        this.policyStatus = data.PolicyStatus;
        this.isWarning = this.checkWarning();
    };

    this.checkWarning = function () {
        let diff = DatetimeHelper.diffCurrentDay(this.coverageEndDate);
        let days = diff.values.days;
        console.log('days', days);
        return days <= 30;
    };
}
